/**
 * @generated SignedSource<<5357b54d73c1ab9f995eb11a0188708d>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/

export type InputMaybe<T> = T | null | undefined;
export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: {
    input: string;
    output: string;
  };
  String: {
    input: string;
    output: string;
  };
  Boolean: {
    input: boolean;
    output: boolean;
  };
  Int: {
    input: number;
    output: number;
  };
  Float: {
    input: number;
    output: number;
  };
  DateTime: {
    input: Date;
    output: Date;
  };
  /** Long type */
  Long: {
    input: number;
    output: number;
  };
  /** High level representation of a Number could be a float or an integer */
  Number: {
    input: number;
    output: number;
  };
}
export interface CommentBody {
  representationFormat: ContentRepresentation;
  value: Scalars["String"]["input"];
}
export enum CommentCreationLocation {
  DATABASE = "DATABASE",
  EDITOR = "EDITOR",
  LIVE = "LIVE",
  RENDERER = "RENDERER",
  WHITEBOARD = "WHITEBOARD",
}
export enum ContentRepresentation {
  ATLAS_DOC_FORMAT = "ATLAS_DOC_FORMAT",
  EDITOR = "EDITOR",
  EDITOR2 = "EDITOR2",
  EXPORT_VIEW = "EXPORT_VIEW",
  PLAIN = "PLAIN",
  RAW = "RAW",
  STORAGE = "STORAGE",
  STYLED_VIEW = "STYLED_VIEW",
  VIEW = "VIEW",
  WIKI = "WIKI",
}
export interface CreateInlineCommentInput {
  commentBody: CommentBody;
  commentSource?: InputMaybe<Platform>;
  containerId: Scalars["ID"]["input"];
  createdFrom: CommentCreationLocation;
  lastFetchTimeMillis: Scalars["Long"]["input"];
  /** matchIndex must be greater than or equal to 0. */
  matchIndex: Scalars["Int"]["input"];
  /** numMatches must be positive and greater than matchIndex. */
  numMatches: Scalars["Int"]["input"];
  originalSelection: Scalars["String"]["input"];
  parentCommentId?: InputMaybe<Scalars["ID"]["input"]>;
  publishedVersion?: InputMaybe<Scalars["Int"]["input"]>;
  step?: InputMaybe<Step>;
}
export interface Mark {
  attrs?: InputMaybe<MarkAttribute>;
  type: Scalars["String"]["input"];
}
export interface MarkAttribute {
  annotationType: Scalars["String"]["input"];
  id: Scalars["String"]["input"];
}
export enum Platform {
  ANDROID = "ANDROID",
  IOS = "IOS",
  WEB = "WEB",
}
export enum SitePermissionType {
  ANONYMOUS = "ANONYMOUS",
  APP = "APP",
  EXTERNAL = "EXTERNAL",
  INTERNAL = "INTERNAL",
  JSD = "JSD",
}
export interface Step {
  from?: InputMaybe<Scalars["Long"]["input"]>;
  mark: Mark;
  pos?: InputMaybe<Scalars["Long"]["input"]>;
  to?: InputMaybe<Scalars["Long"]["input"]>;
}
export type CreateInlineCommentMutation_createInlineComment_Comment_body_DocumentBody =
  {
    __typename?: "DocumentBody";
    value: string;
  };
export type CreateInlineCommentMutation_createInlineComment_Comment_createdAt_Date =
  {
    __typename?: "Date";
    value: string;
  };
export type CreateInlineCommentMutation_createInlineComment_Comment_links_Map_LinkType_String =
  {
    __typename?: "Map_LinkType_String";
    webui: string | null;
    editui: string | null;
  };
export type CreateInlineCommentMutation_createInlineComment_Comment_location_FooterComment_commentResolveProperties_InlineCommentResolveProperties =
  {
    __typename?: "InlineCommentResolveProperties";
    resolved: boolean;
    resolvedFriendlyDate: string | null;
    resolvedTime: number | null;
    resolvedUser: string | null;
  };
export type CreateInlineCommentMutation_createInlineComment_Comment_location_InlineComment_inlineResolveProperties_InlineCommentResolveProperties =
  {
    __typename?: "InlineCommentResolveProperties";
    resolved: boolean;
    isDangling: boolean;
    resolvedFriendlyDate: string | null;
    resolvedTime: number | null;
    resolvedUser: string | null;
  };
export type CreateInlineCommentMutation_createInlineComment_Comment_location_FooterComment =
  {
    __typename?: "FooterComment";
    type: string;
    commentResolveProperties: CreateInlineCommentMutation_createInlineComment_Comment_location_FooterComment_commentResolveProperties_InlineCommentResolveProperties | null;
  };
export type CreateInlineCommentMutation_createInlineComment_Comment_location_InlineComment =
  {
    __typename?: "InlineComment";
    inlineMarkerRef: string | null;
    inlineText: string | null;
    type: string;
    inlineResolveProperties: CreateInlineCommentMutation_createInlineComment_Comment_location_InlineComment_inlineResolveProperties_InlineCommentResolveProperties | null;
  };
export type CreateInlineCommentMutation_createInlineComment_Comment_location =
  | CreateInlineCommentMutation_createInlineComment_Comment_location_FooterComment
  | CreateInlineCommentMutation_createInlineComment_Comment_location_InlineComment;
export type CreateInlineCommentMutation_createInlineComment_Comment_permissions_CommentPermissions =
  {
    __typename?: "CommentPermissions";
    isEditable: boolean;
    isRemovable: boolean;
    isResolvable: boolean;
  };
export type CreateInlineCommentMutation_createInlineComment_Comment_version_Version_by_Anonymous =
  {
    __typename?: "Anonymous";
    displayName: string | null;
  };
export type CreateInlineCommentMutation_createInlineComment_Comment_version_Version_by_KnownUser =
  {
    __typename?: "KnownUser";
    displayName: string | null;
  };
export type CreateInlineCommentMutation_createInlineComment_Comment_version_Version_by_UnknownUser =
  {
    __typename?: "UnknownUser";
    displayName: string | null;
  };
export type CreateInlineCommentMutation_createInlineComment_Comment_version_Version_by_User =
  {
    __typename?: "User";
    displayName: string | null;
  };
export type CreateInlineCommentMutation_createInlineComment_Comment_version_Version_by =

    | CreateInlineCommentMutation_createInlineComment_Comment_version_Version_by_Anonymous
    | CreateInlineCommentMutation_createInlineComment_Comment_version_Version_by_KnownUser
    | CreateInlineCommentMutation_createInlineComment_Comment_version_Version_by_UnknownUser
    | CreateInlineCommentMutation_createInlineComment_Comment_version_Version_by_User;
export type CreateInlineCommentMutation_createInlineComment_Comment_version_Version =
  {
    __typename?: "Version";
    when: string | null;
    number: number | null;
    by: CreateInlineCommentMutation_createInlineComment_Comment_version_Version_by | null;
  };
export type CreateInlineCommentMutation_createInlineComment_Comment_author_Anonymous_profilePicture_Icon =
  {
    __typename?: "Icon";
    path: string;
  };
export type CreateInlineCommentMutation_createInlineComment_Comment_author_Anonymous =
  {
    __typename?: "Anonymous";
    displayName: string | null;
    permissionType: SitePermissionType | null;
    profilePicture: CreateInlineCommentMutation_createInlineComment_Comment_author_Anonymous_profilePicture_Icon | null;
  };
export type CreateInlineCommentMutation_createInlineComment_Comment_author_KnownUser =
  {
    __typename?: "KnownUser";
    accountId: string | null;
    displayName: string | null;
    permissionType: SitePermissionType | null;
    profilePicture: CreateInlineCommentMutation_createInlineComment_Comment_author_Anonymous_profilePicture_Icon | null;
  };
export type CreateInlineCommentMutation_createInlineComment_Comment_author_UnknownUser =
  {
    __typename?: "UnknownUser";
    displayName: string | null;
    permissionType: SitePermissionType | null;
    profilePicture: CreateInlineCommentMutation_createInlineComment_Comment_author_Anonymous_profilePicture_Icon | null;
  };
export type CreateInlineCommentMutation_createInlineComment_Comment_author_User =
  {
    __typename?: "User";
    accountId: string | null;
    displayName: string | null;
    permissionType: SitePermissionType | null;
    profilePicture: CreateInlineCommentMutation_createInlineComment_Comment_author_Anonymous_profilePicture_Icon | null;
  };
export type CreateInlineCommentMutation_createInlineComment_Comment_author =
  | CreateInlineCommentMutation_createInlineComment_Comment_author_Anonymous
  | CreateInlineCommentMutation_createInlineComment_Comment_author_KnownUser
  | CreateInlineCommentMutation_createInlineComment_Comment_author_UnknownUser
  | CreateInlineCommentMutation_createInlineComment_Comment_author_User;
export type CreateInlineCommentMutation_createInlineComment_Comment_reactionsSummary_ReactionsSummaryResponse_reactionsSummaryForEmoji_ReactionsSummaryForEmoji =
  {
    __typename?: "ReactionsSummaryForEmoji";
    id: string;
    emojiId: string;
    count: number;
    reacted: boolean;
  };
export type CreateInlineCommentMutation_createInlineComment_Comment_reactionsSummary_ReactionsSummaryResponse =
  {
    __typename?: "ReactionsSummaryResponse";
    ari: string;
    containerAri: string;
    reactionsCount: number;
    reactionsSummaryForEmoji: Array<CreateInlineCommentMutation_createInlineComment_Comment_reactionsSummary_ReactionsSummaryResponse_reactionsSummaryForEmoji_ReactionsSummaryForEmoji | null>;
  };
export type CreateInlineCommentMutation_createInlineComment_Comment_replies_Comment_body_DocumentBody =
  {
    __typename?: "DocumentBody";
    value: string;
  };
export type CreateInlineCommentMutation_createInlineComment_Comment_replies_Comment_links_Map_LinkType_String =
  {
    __typename?: "Map_LinkType_String";
    webui: string | null;
    editui: string | null;
  };
export type CreateInlineCommentMutation_createInlineComment_Comment_replies_Comment_location_FooterComment_commentResolveProperties_InlineCommentResolveProperties =
  {
    __typename?: "InlineCommentResolveProperties";
    resolved: boolean;
    resolvedFriendlyDate: string | null;
    resolvedTime: number | null;
    resolvedUser: string | null;
  };
export type CreateInlineCommentMutation_createInlineComment_Comment_replies_Comment_location_InlineComment_inlineResolveProperties_InlineCommentResolveProperties =
  {
    __typename?: "InlineCommentResolveProperties";
    resolved: boolean;
    isDangling: boolean;
    resolvedFriendlyDate: string | null;
    resolvedTime: number | null;
    resolvedUser: string | null;
  };
export type CreateInlineCommentMutation_createInlineComment_Comment_replies_Comment_location_FooterComment =
  {
    __typename?: "FooterComment";
    type: string;
    commentResolveProperties: CreateInlineCommentMutation_createInlineComment_Comment_replies_Comment_location_FooterComment_commentResolveProperties_InlineCommentResolveProperties | null;
  };
export type CreateInlineCommentMutation_createInlineComment_Comment_replies_Comment_location_InlineComment =
  {
    __typename?: "InlineComment";
    inlineMarkerRef: string | null;
    inlineText: string | null;
    type: string;
    inlineResolveProperties: CreateInlineCommentMutation_createInlineComment_Comment_replies_Comment_location_InlineComment_inlineResolveProperties_InlineCommentResolveProperties | null;
  };
export type CreateInlineCommentMutation_createInlineComment_Comment_replies_Comment_location =

    | CreateInlineCommentMutation_createInlineComment_Comment_replies_Comment_location_FooterComment
    | CreateInlineCommentMutation_createInlineComment_Comment_replies_Comment_location_InlineComment;
export type CreateInlineCommentMutation_createInlineComment_Comment_replies_Comment_permissions_CommentPermissions =
  {
    __typename?: "CommentPermissions";
    isEditable: boolean;
    isRemovable: boolean;
    isResolvable: boolean;
  };
export type CreateInlineCommentMutation_createInlineComment_Comment_replies_Comment_version_Version_by_Anonymous =
  {
    __typename?: "Anonymous";
    displayName: string | null;
  };
export type CreateInlineCommentMutation_createInlineComment_Comment_replies_Comment_version_Version_by_KnownUser =
  {
    __typename?: "KnownUser";
    displayName: string | null;
  };
export type CreateInlineCommentMutation_createInlineComment_Comment_replies_Comment_version_Version_by_UnknownUser =
  {
    __typename?: "UnknownUser";
    displayName: string | null;
  };
export type CreateInlineCommentMutation_createInlineComment_Comment_replies_Comment_version_Version_by_User =
  {
    __typename?: "User";
    displayName: string | null;
  };
export type CreateInlineCommentMutation_createInlineComment_Comment_replies_Comment_version_Version_by =

    | CreateInlineCommentMutation_createInlineComment_Comment_replies_Comment_version_Version_by_Anonymous
    | CreateInlineCommentMutation_createInlineComment_Comment_replies_Comment_version_Version_by_KnownUser
    | CreateInlineCommentMutation_createInlineComment_Comment_replies_Comment_version_Version_by_UnknownUser
    | CreateInlineCommentMutation_createInlineComment_Comment_replies_Comment_version_Version_by_User;
export type CreateInlineCommentMutation_createInlineComment_Comment_replies_Comment_version_Version =
  {
    __typename?: "Version";
    when: string | null;
    number: number | null;
    by: CreateInlineCommentMutation_createInlineComment_Comment_replies_Comment_version_Version_by | null;
  };
export type CreateInlineCommentMutation_createInlineComment_Comment_replies_Comment_author_Anonymous_profilePicture_Icon =
  {
    __typename?: "Icon";
    path: string;
  };
export type CreateInlineCommentMutation_createInlineComment_Comment_replies_Comment_author_Anonymous =
  {
    __typename?: "Anonymous";
    displayName: string | null;
    permissionType: SitePermissionType | null;
    profilePicture: CreateInlineCommentMutation_createInlineComment_Comment_replies_Comment_author_Anonymous_profilePicture_Icon | null;
  };
export type CreateInlineCommentMutation_createInlineComment_Comment_replies_Comment_author_KnownUser =
  {
    __typename?: "KnownUser";
    accountId: string | null;
    displayName: string | null;
    permissionType: SitePermissionType | null;
    profilePicture: CreateInlineCommentMutation_createInlineComment_Comment_replies_Comment_author_Anonymous_profilePicture_Icon | null;
  };
export type CreateInlineCommentMutation_createInlineComment_Comment_replies_Comment_author_UnknownUser =
  {
    __typename?: "UnknownUser";
    displayName: string | null;
    permissionType: SitePermissionType | null;
    profilePicture: CreateInlineCommentMutation_createInlineComment_Comment_replies_Comment_author_Anonymous_profilePicture_Icon | null;
  };
export type CreateInlineCommentMutation_createInlineComment_Comment_replies_Comment_author_User =
  {
    __typename?: "User";
    accountId: string | null;
    displayName: string | null;
    permissionType: SitePermissionType | null;
    profilePicture: CreateInlineCommentMutation_createInlineComment_Comment_replies_Comment_author_Anonymous_profilePicture_Icon | null;
  };
export type CreateInlineCommentMutation_createInlineComment_Comment_replies_Comment_author =

    | CreateInlineCommentMutation_createInlineComment_Comment_replies_Comment_author_Anonymous
    | CreateInlineCommentMutation_createInlineComment_Comment_replies_Comment_author_KnownUser
    | CreateInlineCommentMutation_createInlineComment_Comment_replies_Comment_author_UnknownUser
    | CreateInlineCommentMutation_createInlineComment_Comment_replies_Comment_author_User;
export type CreateInlineCommentMutation_createInlineComment_Comment_replies_Comment_reactionsSummary_ReactionsSummaryResponse_reactionsSummaryForEmoji_ReactionsSummaryForEmoji =
  {
    __typename?: "ReactionsSummaryForEmoji";
    id: string;
    emojiId: string;
    count: number;
    reacted: boolean;
  };
export type CreateInlineCommentMutation_createInlineComment_Comment_replies_Comment_reactionsSummary_ReactionsSummaryResponse =
  {
    __typename?: "ReactionsSummaryResponse";
    ari: string;
    containerAri: string;
    reactionsCount: number;
    reactionsSummaryForEmoji: Array<CreateInlineCommentMutation_createInlineComment_Comment_replies_Comment_reactionsSummary_ReactionsSummaryResponse_reactionsSummaryForEmoji_ReactionsSummaryForEmoji | null>;
  };
export type CreateInlineCommentMutation_createInlineComment_Comment_replies_Comment =
  {
    __typename?: "Comment";
    id: string;
    contentStatus: string;
    createdAtNonLocalized: string;
    parentId: string | null;
    body: CreateInlineCommentMutation_createInlineComment_Comment_replies_Comment_body_DocumentBody;
    createdAt: CreateInlineCommentMutation_createInlineComment_Comment_createdAt_Date;
    links: CreateInlineCommentMutation_createInlineComment_Comment_replies_Comment_links_Map_LinkType_String;
    location: CreateInlineCommentMutation_createInlineComment_Comment_replies_Comment_location;
    permissions: CreateInlineCommentMutation_createInlineComment_Comment_replies_Comment_permissions_CommentPermissions;
    version: CreateInlineCommentMutation_createInlineComment_Comment_replies_Comment_version_Version;
    author: CreateInlineCommentMutation_createInlineComment_Comment_replies_Comment_author;
    reactionsSummary: CreateInlineCommentMutation_createInlineComment_Comment_replies_Comment_reactionsSummary_ReactionsSummaryResponse | null;
  };
export type CreateInlineCommentMutation_createInlineComment_Comment = {
  __typename?: "Comment";
  id: string;
  contentStatus: string;
  createdAtNonLocalized: string;
  parentId: string | null;
  body: CreateInlineCommentMutation_createInlineComment_Comment_body_DocumentBody;
  createdAt: CreateInlineCommentMutation_createInlineComment_Comment_createdAt_Date;
  links: CreateInlineCommentMutation_createInlineComment_Comment_links_Map_LinkType_String;
  location: CreateInlineCommentMutation_createInlineComment_Comment_location;
  permissions: CreateInlineCommentMutation_createInlineComment_Comment_permissions_CommentPermissions;
  version: CreateInlineCommentMutation_createInlineComment_Comment_version_Version;
  author: CreateInlineCommentMutation_createInlineComment_Comment_author;
  reactionsSummary: CreateInlineCommentMutation_createInlineComment_Comment_reactionsSummary_ReactionsSummaryResponse | null;
  replies: Array<CreateInlineCommentMutation_createInlineComment_Comment_replies_Comment | null>;
};
export type CreateInlineCommentMutation_Mutation = {
  __typename?: "Mutation";
  createInlineComment: CreateInlineCommentMutation_createInlineComment_Comment;
};
export type CreateInlineCommentMutationVariables = Exact<{
  input: CreateInlineCommentInput;
  pageId: Scalars["ID"]["input"];
}>;
export type CreateInlineCommentMutation = CreateInlineCommentMutation_Mutation;
